<template>
  <div class="p-grid" v-if="enums">
    <Toast position="bottom-left" />

    <div v-for="$enum of enums" :key="$enum.name" class="p-col-12 p-lg-3">
      <div class="card summary p-shadow-1">
        <h4 class="title">
          <i :class="$enum.icon"></i>
          {{$enum.label}}
        </h4>
        <div class="p-d-flex" dir="ltr">
          <router-link :to="`/Enum/Edit/${$enum.id}`">
            <Button class="p-button-success p-button-sm p-mr-1">ویرایش</Button>
          </router-link>
          <Button class="p-button-warning p-button-sm" @click="confirmDeleteEnum($enum)">حذف</Button>
        </div>
      </div>
    </div>
    <div class="p-col-12 p-lg-12">
      <Button
        type="submit"
        @click="createItemDialog = true"
        class="p-button-success p-mr-2"
      >درج enum جدید</Button>
    </div>

    <Dialog
      :visible.sync="createItemDialog"
      :style="{width: '450px'}"
      header="enum جدید"
      :modal="true"
    >
      <div class="p-fluid">
        <div class="p-field">
          <label for="enumName">Enum</label>
          <InputText dir="ltr" placeholder="Example: Gender" type="text" v-model="enumName" />
        </div>
        <div class="p-field">
          <label for="enumLabel">عنوان فارسی</label>
          <InputText placeholder="مثلا جنسیت" type="text" v-model="enumLabel" />
        </div>
      </div>
      <template #footer>
        <Button
          label="لغو"
          icon="pi pi-times"
          class="p-button-text"
          @click="createItemDialog = false"
        />
        <Button label="ایجاد" icon="pi pi-check" class="p-button-text" @click="createEnum" />
      </template>
    </Dialog>

    <Dialog
      :visible.sync="deleteItemDialog"
      :style="{width: '450px'}"
      header="تایید حذف"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>آیا از حذف مورد انتخاب شده مطمئن هستید؟</span>
      </div>
      <template #footer>
        <Button
          label="خیر"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteItemDialog = false"
        />
        <Button label="بله" icon="pi pi-check" class="p-button-text" @click="deleteEnum" />
      </template>
    </Dialog>
  </div>
</template>
<script>
import { getters, actions } from "../../store.js";
import CrudService from "../../service/CrudService";
export default {
  data() {
    return {
      enums: null,
      enum: null,
      enumName: null,
      enumLabel: null,
      createItemDialog: false,
      deleteItemDialog: false,
    };
  },
  service: null,
  methods: {
    showCreateModal() {
      this.createItemDialog = true;
    },
    confirmDeleteEnum($enum) {
      this.enum = $enum;
      this.deleteItemDialog = true;
    },
    async deleteEnum() {
      const result = await this.service.deleteItem(this.enum.id);
      await actions.loadEnums();
      this.enums = getters.enums();
      this.deleteItemDialog = false;
      this.enumName = this.enumLabel = null;
    },
    async createEnum() {
      const result = await this.service.create({
        name: this.enumName,
        label: this.enumLabel,
        pluralLabel: this.enumLabel,
        autoGenerated: true,
        icon: "pi pi-check",
      });

      await actions.loadEnums();
      this.enums = getters.enums();

      this.createItemDialog = false;
      this.enumName = this.enumLabel = null;
    },
  },
  async created() {
    this.service = new CrudService("Enum", this);
    await actions.loadEnums();
    this.enums = getters.enums();
  },
};
</script>